import { useTranslation } from 'react-i18next';

import { TextWithIcon } from '@/ui';
import { TranslatedChatPartComponent } from './TranslatedChatPartComponent';

export type CallerMessagePreviewComponentProps = {
  messagePreview: string | null;
  translateChat: boolean;
};

export function CallerMessagePreviewComponent({ messagePreview, translateChat }: CallerMessagePreviewComponentProps) {
  const { t } = useTranslation();

  if (messagePreview === null || messagePreview.trim() === '') {
    return null;
  }

  return (
    <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-white border border-1 border-dark border-dashed">
      <div className="x-small text-muted fa-fade">
        <TextWithIcon icon="fal fa-message-pen" text={t('Chat_CallerIsTyping')} />
      </div>
      <div>{messagePreview}</div>

      <TranslatedChatPartComponent message={messagePreview} translateChat={translateChat} />
    </div>
  );
}
